import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-16-减号",
  "use": "icon-16-减号-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 16 16\" id=\"icon-16-减号\">\n<style type=\"text/css\">\n\t#icon-16-减号 .st0{fill:#556655;}\n</style>\n<g>\n\t<rect y=\"7\" class=\"st0\" width=\"16\" height=\"2\" />\n</g>\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol